const TICKET = {
  STATES: {
    EXECUTED: 3,
    CANCELED: 4,
    IN_BROKER: 7
  }
};

export default TICKET;
